(function () {
  function initCarouselProgress(root) {
    (root || document)
      .querySelectorAll('.oadsy-showcase__slider-component:not([data-progress-ready])')
      .forEach(function (component) {
        component.setAttribute('data-progress-ready', '');

        var carousel = component.querySelector('.oadsy-showcase__carousel');
        var thumb    = component.querySelector('.oadsy-showcase__progress-thumb');
        if (!carousel || !thumb) return;

        function update() {
          var scrollable = carousel.scrollWidth - carousel.clientWidth;
          if (scrollable <= 0) {
            thumb.style.width     = '100%';
            thumb.style.transform = 'translateX(0)';
            return;
          }
          var visibleRatio = carousel.clientWidth / carousel.scrollWidth;
          var progress     = carousel.scrollLeft / scrollable;
          var trackWidth   = carousel.clientWidth;
          var thumbPx      = visibleRatio * trackWidth;
          var maxShift     = trackWidth - thumbPx;
          thumb.style.width     = thumbPx.toFixed(2) + 'px';
          thumb.style.transform = 'translateX(' + (progress * maxShift).toFixed(2) + 'px)';
        }

        var resizeTimer;
        function onResize() {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(update, 150);
        }

        carousel.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', onResize, { passive: true });
        requestAnimationFrame(function () { requestAnimationFrame(update); });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCarouselProgress(); });
  } else {
    initCarouselProgress();
  }

  // Re-init when a section is added/reloaded in the Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    initCarouselProgress(e.target);
  });
})();
